module.exports = __webpack_public_path__ + "img/9.c7fa6362.png";